import {useLogout} from "@mytour/platform";
import {Loading} from "@mytour/ui/Loading";
import {useLayoutEffect} from "react";

export const LogoutPage = () => {
  const {logout} = useLogout();

  useLayoutEffect(() => {
    const handleLogout = async () => {
      await logout();
      window.location.href = `${window.location.origin}`;
    };
    handleLogout();
  }, [logout]);

  return <Loading />;
};
